import { gql } from "@apollo/client";

export default gql`
  query getCallAdminLogs($params: GetCallAdminLogsInput!){
    getCallAdminLogs(params: $params){
        success
        data{
            logs{
                _id
                callSid
                parentCallSid
                childCallSids
                customer
                customerName
                platformId
                callType
                callerCPersonId
                calleeCPersonId
                callerName
                calleeName
                status
                direction
                logs{
                    stepName
                    type
                    status
                    correlationId
                    data
                    duration
                    timestamp
                    message
                    error
                }
                createdAt
                updatedAt
                callerNumber
                totalDuration
                totalCost
            }
            total
        }
        code
        message
    }
}
`
